import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";
import {
  Card,
  CardActions,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Chip,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Switch from "@mui/material/Switch";
import ReadMoreAndLess from "react-read-more-less";
import Cisinformation from "../Components/Cisinformation/Cisinformation";

function EnhancedTableHead() {
  return (
    <>
      <TableHead className="bg-lightBlue-200">
        <TableRow className="align-items-center table-flush css-serial">
          <TableCell width="5%" padding="checkbox"></TableCell>
          <TableCell width="5%" align="center">
            <h6>Cis_no</h6>
          </TableCell>
          <TableCell align="center">
            <h6>CIS_Topic</h6>
          </TableCell>
          <TableCell align="center">
            <h6>More_Info</h6>
          </TableCell>
        </TableRow>
      </TableHead>
    </>
  );
}

function AuditTable(props) {
  const {
    CisResults,
    selected,
    setSelected,
    name,
    os_type,
    handleSubmitClick,
    setPage
  } = props;

  const [newresult, setNewresult] = React.useState([]);
  const [itemselected, setItemselected] = React.useState([]);
  const [tempselected, setTempselected] = React.useState([]);
  const [oldselected, setOldselected] = React.useState([]);

  const handlePageChange = (e) => {
    setPage(1);
  };
  
  useEffect(() => {
    setNewresult({ CisResults });
    if (CisResults) {
      CisResults.map((val) => {
        val.result.map((row) => {
          setdropdown((prevState) => ({ ...prevState, [row.cis_no]: false }));
        });
      });
    }
  }, [CisResults]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const totalselected = CisResults.map((row) => {
        const seperateResult = row.result.map((value) => {
          const cis_number = value.cis_no;
          return cis_number;
        });
        return seperateResult;
      });

      const data = JSON.stringify(totalselected);
      const jsonstrinifydata = data
        .replace(/\[/g, "")
        .replace(/\]/g, "")
        .replace(/[,]+/g, ",");
      const changeValue = "[" + jsonstrinifydata + "]";
      const jsonparsefield = JSON.parse(changeValue);
      const filtered = jsonparsefield.filter(function (el) {
        return el != null;
      });

      setSelected(filtered);
      setItemselected(filtered);
      return null;
    }
    setSelected([]);
    return null;
  };

  const handleSelectGroupClick = (event, tags) => {
    if (event.target.checked) {
      let newSelected = [];
      newSelected = newSelected.concat(selected, tags);
      setOldselected(newSelected);
      setSelected(newSelected);
      setTempselected(tags);
      return null;
    }
    tags.map((row) => {
      var index = oldselected.indexOf(row);
      if (index !== -1) {
        oldselected.splice(index, 1);
        setSelected(selected);
      }
    });
    setTempselected([]);
    return null;
  };

  const handleClick = (event, cis_no) => {
    const selectedIndex = selected.indexOf(cis_no);
    let newSelected = [];
    console.log(selected);

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, cis_no);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    const totalselected = CisResults.map((row) => {
      const seperateResult = row.result.map((value) => {
        const cis_number = value.cis_no;
        return cis_number;
      });
      return seperateResult;
    });

    const data = JSON.stringify(totalselected);
    const jsonstrinifydata = data
      .replace(/\[/g, "")
      .replace(/\]/g, "")
      .replace(/[,]+/g, ",");
    const changeValue = "[" + jsonstrinifydata + "]";
    const jsonparsefield = JSON.parse(changeValue);
    const filtered = jsonparsefield.filter(function (el) {
      return el != null;
    });
    setSelected(newSelected);
    setItemselected(filtered);
  };

  const isSelected = (cis_no) => selected.indexOf(cis_no) !== -1;

  const [expandedheader, setExpandedheader] = React.useState({});

  const handleChangedropdown = (panel) => (event, isExpanded) => {
    setExpandedheader(isExpanded ? panel : false);
  };

  const filterHandle = () => {
    setExpandedheader({ expandedheader: true });
  };

  const handleCollapse = () => {
    setExpandedheader(false);
  };
  const [dropdown, setdropdown] = React.useState([]);
  const checkmoreinfo = (cis_no) => (e) => {
    e.preventDefault();
    var value;
    if (dropdown[cis_no]) {
      value = false;
    } else {
      value = true;
    }
    setdropdown((prevState) => ({ ...prevState, [cis_no]: value }));
  };

  return (
    <React.Fragment>
      <Card>
        <CardHeader title={`Platform: ${os_type}`} />

        <div className="mr-2 px-4 py-2">
          <Chip
            icon={
              <React.Fragment>
                <Checkbox
                  indeterminate={
                    selected.length > 0 && selected.length < itemselected.length
                  }
                  checked={
                    itemselected.length > 0 &&
                    selected.length === itemselected.length
                  }
                  onChange={handleSelectAllClick}
                  inputProps={{ "aria-label": "select all desserts" }}
                  title="select all"
                />
              </React.Fragment>
            }
            label={
              <Typography fontWeight="fontWeightBold" variant="h7">
                <strong>Select all</strong>
              </Typography>
            }
            variant="outlined"
          />
        </div>
        {newresult.CisResults ? (
          <React.Fragment>
            {CisResults.map((val, index) => {
              const labelId = `select all desserts-${index}`;
              const tags = val.tags;
              if (tags.length > 0) {
                return (
                  <React.Fragment>
                    <Accordion
                      defaultExpanded={expandedheader ? true : false}
                      onChange={handleChangedropdown(val.header_id)}
                      style={{ cursor: "pointer" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography fontWeight="fontWeightBold" variant="h7">
                          <strong>{val.header_id}</strong> - {val.header_name}
                        </Typography>
                      </AccordionSummary>
                      {val.header_userData === "yes" ? (
                        <AccordionDetails
                          style={{ justifyContent: "space-between" }}
                        >
                          <Chip
                            icon={
                              <React.Fragment>
                                <Checkbox
                                  indeterminate={
                                    tempselected.length > 0 &&
                                    tempselected.length > selected.length
                                  }
                                  checked={
                                    (selected.length > 0 &&
                                      tempselected.length > 0) ||
                                    (tempselected.length !== 0 &&
                                      itemselected.length > 0 &&
                                      selected.length === itemselected.length)
                                  }
                                  onChange={(event) =>
                                    handleSelectGroupClick(event, tags)
                                  }
                                  inputProps={{
                                    "aria-label": "select all desserts",
                                  }}
                                  title="select all"
                                />
                              </React.Fragment>
                            }
                            label={
                              <Typography
                                fontWeight="fontWeightBold"
                                variant="h7"
                              >
                                <strong>Select all</strong>
                              </Typography>
                            }
                            variant="outlined"
                          />
                        </AccordionDetails>
                      ) : (
                        ""
                      )}
                      <AccordionDetails>
                        <TableContainer
                          component={Paper}
                          style={{ borderColor: "#333" }}
                        >
                          <Table
                            aria-labelledby="tableTitle"
                            aria-label="enhanced table"
                            bordered
                          >
                            <EnhancedTableHead />
                            <TableBody>
                              {val.result.map((row, sindex) => {
                                const isItemSelected = isSelected(row.cis_no);
                                const labelId = `enhanced-table-checkbox-${sindex}`;
                                return (
                                  <React.Fragment>
                                    <TableRow>
                                      <TableCell width="15%" padding="checkbox">
                                        <Checkbox
                                          hover
                                          disabled={
                                            val.header_userData === "yes"
                                              ? true
                                              : false
                                          }
                                          onClick={(event) =>
                                            handleClick(event, row.cis_no)
                                          }
                                          role="checkbox"
                                          aria-checked={isItemSelected}
                                          tabIndex={-1}
                                          selected={isItemSelected}
                                          checked={isItemSelected}
                                          inputProps={{
                                            "aria-labelledby": labelId,
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        component="th"
                                        id={labelId}
                                        scope="row"
                                        padding="none"
                                        width="15%"
                                      >
                                        {row.cis_no}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          textAlign: "left",
                                          whiteSpace: "normal",
                                          wordWrap: "break-word",
                                        }}
                                      >
                                        <ReadMoreAndLess
                                          className="read-more-content"
                                          charLimit={100}
                                          readMoreText="Read more"
                                          readLessText="Read less"
                                        >
                                          {row.cis_topic_name}
                                        </ReadMoreAndLess>
                                      </TableCell>
                                      <TableCell width="5%" align="center">
                                        <IconButton
                                          color="primary"
                                          size="sm"
                                          title="Info"
                                          style={{
                                            padding: "0px",
                                            // color: "lightgreen",
                                          }}
                                          onClick={checkmoreinfo(row.cis_no)}
                                        >
                                          {dropdown[row.cis_no] ? (
                                            <KeyboardArrowUpIcon fontSize="small" />
                                          ) : (
                                            <KeyboardArrowDownIcon fontSize="small" />
                                          )}
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    {dropdown[row.cis_no] ? (
                                      <TableRow
                                        id={"multiCollapse" + row.cis_no}
                                      >
                                        <Cisinformation
                                          OS={os_type}
                                          FactName={row.fact_name}
                                        />
                                      </TableRow>
                                    ) : (
                                      ""
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </AccordionDetails>
                    </Accordion>
                  </React.Fragment>
                );
              }
            })}
          </React.Fragment>
        ) : (
          ""
        )}
        <br />
        <br />
        <CardActions style={{ float: "right" }}>
          <button
            className="bg-blueGray-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="button"
            style={{ float: "right" }}
          >
            <Link
              to={{
                pathname: "/admin/templates",
              }}
            >
              Cancel
            </Link>
          </button>
          <button
            className={
              name && os_type && selected.length > 0
                ? "bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                : "bg-lightBlue-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            }
            size="sm"
            onClick={handlePageChange}
            style={{ float: "right" }}
            disabled={name && os_type && selected.length > 0 ? false : true}
          >
              Next
          </button>          
        </CardActions>
      </Card>
    </React.Fragment>
  );
}

export default AuditTable;